/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { BatchEditSetDataRowRequest } from '../models/BatchEditSetDataRowRequest';
import type { BatchSetAddExpense } from '../models/BatchSetAddExpense';
import type { BatchSetAddResponse } from '../models/BatchSetAddResponse';
import type { ConvertAuthorizedAmountRequest } from '../models/ConvertAuthorizedAmountRequest';
import type { ConvertAuthorizedAmountResponse } from '../models/ConvertAuthorizedAmountResponse';
import type { DuplicateCheckResultDto } from '../models/DuplicateCheckResultDto';
import type { ExpenseIdentifier } from '../models/ExpenseIdentifier';
import type { ISaveStatus } from '../models/ISaveStatus';
import type { RequestStatusDTO } from '../models/RequestStatusDTO';
import type { RequestTypeValueEnum } from '../models/RequestTypeValueEnum';
import type { SetQuery } from '../models/SetQuery';
import type { StudyExpenseTrackingDataRowDto } from '../models/StudyExpenseTrackingDataRowDto';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class ExpenseTrackingService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param requestBody
     * @returns StudyExpenseTrackingDataRowDto
     * @throws ApiError
     */
    public expenseTrackingGetStudyExpenseTrackingData(
        requestBody: Array<ExpenseIdentifier>,
    ): Observable<Array<StudyExpenseTrackingDataRowDto>> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/expense-tracking/by-ids',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param studyId
     * @param requestType
     * @param requestId
     * @returns StudyExpenseTrackingDataRowDto
     * @throws ApiError
     */
    public expenseTrackingGetStudyExpenseTrackingDataByRequest(
        studyId: number,
        requestType: RequestTypeValueEnum,
        requestId: number,
    ): Observable<Array<StudyExpenseTrackingDataRowDto>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/expense-tracking/studies/{studyId}/request/{requestType}/{requestId}',
            path: {
                'studyId': studyId,
                'requestType': requestType,
                'requestId': requestId,
            },
        });
    }
    /**
     * @param studyId
     * @param requestBody
     * @returns StudyExpenseTrackingDataRowDto
     * @throws ApiError
     */
    public expenseTrackingGetData(
        studyId: number,
        requestBody: SetQuery,
    ): Observable<Array<StudyExpenseTrackingDataRowDto>> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/expense-tracking/{studyId}/filtered',
            path: {
                'studyId': studyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ISaveStatus
     * @throws ApiError
     */
    public expenseTrackingCompleteReimbursementRequest(
        requestBody: RequestStatusDTO,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/expense-tracking/reimbursement/complete',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ISaveStatus
     * @throws ApiError
     */
    public expenseTrackingCompleteStipendRequest(
        requestBody: RequestStatusDTO,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/expense-tracking/stipend/complete',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ISaveStatus
     * @throws ApiError
     */
    public expenseTrackingCompleteTravelRequest(
        requestBody: RequestStatusDTO,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/expense-tracking/travel/complete',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param studyId
     * @param requestBody
     * @returns number
     * @throws ApiError
     */
    public expenseTrackingPatchBatchExpense(
        studyId: number,
        requestBody: Array<BatchEditSetDataRowRequest>,
    ): Observable<number> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/api/expense-tracking/{studyId}/batch',
            path: {
                'studyId': studyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ConvertAuthorizedAmountResponse
     * @throws ApiError
     */
    public expenseTrackingBatchConvertAuthorizedAmount(
        requestBody: Array<ConvertAuthorizedAmountRequest>,
    ): Observable<Array<ConvertAuthorizedAmountResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/expense-tracking/batch/convert',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns BatchSetAddResponse
     * @throws ApiError
     */
    public expenseTrackingCreateReimbursementRequestExpense(
        requestBody: Array<BatchSetAddExpense>,
    ): Observable<Array<BatchSetAddResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/expense-tracking/reimbursement/new-expenses',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns DuplicateCheckResultDto
     * @throws ApiError
     */
    public expenseTrackingCheckForDuplicates(
        requestBody: Array<BatchEditSetDataRowRequest>,
    ): Observable<DuplicateCheckResultDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/expense-tracking/check-duplicates',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
